export const typesFlyreview = {
    GET_FLYREVIEW_SUCCESS:'GET_FLYREVIEW_SUCCESS',
    GET_FLYREVIEW_ERROR:'GET_FLYREVIEW_ERROR',
    GET_FLYREVIEW_BEGIN:'GET_FLYREVIEW_BEGIN',
    FLYMYRESERVATIONS_PRIMARY_ADDRESS: 'FLYMYRESERVATIONS_PRIMARY_ADDRESS',
    FLYMYRESERVATIONS_PRIMARY_ADDRESS_LOAD_SUCCESS_DO_NOTHING: 'FLYMYRESERVATIONS_PRIMARY_ADDRESS_LOAD_SUCCESS_DO_NOTHING',

    GET_FLY_PRICEANDTAX_SUCCESS:'GET_FLY_PRICEANDTAX_SUCCESS',
    GET_FLY_PRICEANDTAX_ERROR:'GET_FLY_PRICEANDTAX_ERROR',
    GET_FLY_PRICEANDTAX_BEGIN:'GET_FLY_PRICEANDTAX_BEGIN',
    RESET_FLY_PRICEANDTAX_INIT: 'RESET_FLY_PRICEANDTAX_INIT'
}
